import { alpha } from "@mui/material";
const styles = (theme) => ({
  boxTitle: {
    px: 2,
    pt: 1,
    display: "flex",
    flexDirection: "row",
    gap: 1,
    justifyContent: "space-between",
    alignItems: "center",
  },
  titleIcon: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  },
  gridContent: { maxHeight: 500, minHeight: 500 },
  gridContentChart: { display: "flex", minHeight: 280, maxHeight: 280 },
  paperContent: {
    display: "flex",
    width: "100%",
    height: "100%",
    borderRadius: 4,
    gap: 0,
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  paperGraphcs: {
    display: "flex",
    p: 1,
    borderRadius: 4,
    flexDirection: "column",
    gap: 1,
    flexGrow: 1,
  },
  boxTitleGraphcs: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  toggleViewButton: {
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 2,
    width: 28,
    height: 28,
  },
});

export default styles;
